import { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { t } from "i18next";
import MyButton from "../UI/Button";
import { useCreateByBarcodesMutation, useGetOrderSearchByBarcodesQuery, usePandingToProcessMutation } from "../../store/api/orderAPI";
import { Toast } from "primereact/toast";
import { orderProcColumn } from "../../metadata/order";
import { useTranslatedColumns } from "../../hooks/useTranslatedColumns";
import PresortDemo from "../table/DataTable";
import { useNavigate } from "react-router-dom";
import { useActionsHook } from "../../hooks/useActionsHook";

function AddOrder({ onClose }) {
    const [barcode, setBarcode] = useState("");
    const navigate = useNavigate();
    const inp = useRef(null);
    const [barcodes, setBarcodes] = useState([]);

    const [createByBarcodes] = useCreateByBarcodesMutation();
    const [pandingToProccess] = usePandingToProcessMutation();
    const orderColumnTr = useTranslatedColumns(orderProcColumn);

    const { data: orders = [], isLoading } = useGetOrderSearchByBarcodesQuery(
        { tcodes: barcodes },
        { skip: !barcodes.length }
    );

    const toast = useRef(null);

    const actions = useActionsHook([
        {
            onClick: async (e, data) => {
                const res = await pandingToProccess(data);

                if (res.data?.success) {
                    toast.current.show({
                        severity: "success",
                        summary: "Успешно",
                        detail: "Добавлен на обработку",
                        life: 2000,
                    });
                }
            },
            icon: "pi pi-plus"
        }
    ]);

    const handleAdd = () => {
        if (barcode.trim() !== "") {
            setBarcodes([...barcodes, barcode.trim()]);
            setBarcode("");
        }
    };

    const handleSave = async () => {
        const result = await createByBarcodes({ barcodes: barcodes });

        if (result.data?.success && Array.isArray(result.data?.result) && result.data?.result[0].Message == 'Заказ успешно создан') {
            toast.current.show({
                severity: "success",
                summary: "Success",
                detail: result.data?.result[0].Message,
                life: 3000,
            });
            setBarcodes([])
        } else if (result.data?.success && Array.isArray(result.data?.result) && result.data?.result[0].Message) {
            toast.current.show({
                severity: "info",
                summary: "Success",
                detail: result.data?.result[0].Message,
                life: 3000,
            });
            setBarcodes([])
        } else {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Не удалось создать заказ",
                life: 3000,
            });
        }


    };

    useEffect(() => {
        if (inp.current) {
            setTimeout(() => inp.current.focus(), 200);
        }
    }, []);

    return (
        <>
            <Toast ref={toast} />

            <div className="add-order">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-qrcode" />
                    <InputText
                        ref={inp}
                        value={barcode}
                        style={{ padding: 8, paddingLeft: 38 }}
                        onChange={(e) => setBarcode(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && barcode.trim() !== "") {
                                handleAdd();
                            }
                        }}
                        placeholder="Scan"
                    />
                </IconField>

                <MyButton
                    label={t("add")}
                    severity="info"
                    outlined
                    size="small"
                    onClick={handleAdd}
                />
            </div>

            {/* Список баркодов с возможностью удаления */}
            <ul>
                {barcodes.map((code, idx) => (
                    <li key={idx} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span>{code}</span>
                        <MyButton
                            label="❌"
                            size="small"
                            severity="danger"
                            onClick={() => setBarcodes(barcodes.filter((_, i) => i !== idx))}
                        />
                    </li>
                ))}
            </ul>

            {(orders.length) ? (
                <PresortDemo
                    isLoading={isLoading}
                    data={orders}
                    column={orderColumnTr.filter(i => !i.hidden) ?? Object.keys(orders.data?.[0] || {})}
                    // height="160px"
                    toggleSidebar={() => { }}
                    actions={actions}
                />
            ) : (
                barcodes.length ? <div className="flex justify-content-end" style={{ marginTop: 12 }}>
                    <MyButton label={t("save")} size="small" onClick={handleSave} />
                </div> : ""
            )}
        </>
    );
}

export default AddOrder;
